import UpdateGlobalOptions from "pages/Masters/UpdateGlobalOptions"

export const API_WEB_URLS = {
  // BASE: "http://192.168.31.70:7037/api/V1/",
  // BASE: "https://localhost:44379/api/V1/",
  // BASE: "https://localhost:44379/api/V1/",
  BASE: "https://ApiTradingParty.shinewellsofttech.co.in/api/V1/",
  // BASE: "https://ApiBrokerGta.shinewellsofttech.co.in/api/V1/",
  // BASE: "https://ApiSKumar.shinewellsofttech.co.in/api/V1/",

  LOGIN: "Authentication/Login",
  // IMAGEURL: "https://10.222.92.203:7037/MemberImages/",
  IMAGEURL: "https://ApiBrokerShreeram.shinewellsofttech.co.in/MemberImages/",

  //IMAGEURL_PDF: "https://ApiBrokerShreeram.shinewellsofttech.co.in/MemberImages/PDF/",

  MASTER: "Masters",
  BrokerageCalculation: "BrokerageCalculation",
  VoucherListBro: "VoucherListBro",
  VoucherBro: "VoucherBro",
  LedgerRegisterBro: "LedgerRegisterBro",
  VoucherList: "VoucherList",
  UserMaster: "UserMaster",
  UserMaster: "UserMaster",
  CourseMasterH: "CourseMasterH",
  CourseMasterL: "CourseMasterL",
  UserMasterNew: "UserMasterNew",
  UserTypeMaster: "UserTypeMaster",
  LedgerMaster: "LedgerMaster",
  ReminderData: "ReminderData",
  ItemTypeMaster: "ItemTypeMaster",
  UnitMaster: "UnitMaster",
  ItemMaster: "ItemMaster",
  ContractType: "ContractType",
  TransportMaster: "TransportMaster",
  DeleteContract: "DeleteContract",
  DeletePartyAccount: "DeletePartyAccount",
  DeleteVoucherNew: "DeleteVoucherNew",
  DeleteVoucherBro: "DeleteVoucherBro",
  DalaliMaster: "DalaliMaster",
  StateMaster: "StateMaster",
  CityMaster: "CityMaster",
  UpdateGlobalOptions: "UpdateGlobalOptions",
  ContractH: "ContractH",
  AddLifting: "AddLifting",
  GetLedgerReport: "GetLedgerReport",
  VoucherH: "VoucherH",
  ContractEditData: "ContractEditData",
  ContractEditDataApp: "ContractEditDataApp",
  ContractHHistory: "ContractHHistory",
  ContractForLinkRegister: "ContractForLinkRegister",
  LedgerDalaliCalculation: "LedgerDalaliCalculation",
  PartyNewLedgerBrokerWise: "PartyNewLedger/BrokerWise",
  PartyNewLedgerPartyWise: "PartyNewLedger/PartyWise",
  SaudaPosition: "SaudaPosition",
  ContractMultiPrint: "ContractMultiPrint",
  GetLedgerReportApp: "GetLedgerReportApp",
  PeriodData: "PeriodData",
  GetLedgerReportApp: "GetLedgerReportApp",
  GetDalaliLedgerData: "GetDalaliLedgerData",
  QtyDifferenceAudit: "QtyDifferenceAudit",
  Token:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImluZm9Ac2hpbmV3ZWxsaW5ub3ZhdGlvbi5jb20iLCJuYW1laWQiOiIxIiwidW5pcXVlX25hbWUiOiIzMTZiYmI3Ny1kOWIxLTQwNWYtYWRiYy01YzYyN2I0M2YwOWQiLCJJUCI6IjQ5LjQzLjE3Ni45NSIsImlzc3VlZF9kYXRlIjoiMTY5NDQzMjU3MyIsIm5iZiI6MTY5NDQzMjU3MywiZXhwIjoxNjk1MDM3MzczLCJpYXQiOjE2OTQ0MzI1NzMsImlzcyI6Imh0dHA6Ly9zaGluZXdlbGxzb2Z0dGVjaC5jby5pbjo1MDY5My9yZXBvcnRpbmcvc2l0ZS9zaXRlMSIsImF1ZCI6Imh0dHA6Ly9zaGluZXdlbGxzb2Z0dGVjaC5jby5pbjo1MDY5My9yZXBvcnRpbmcvc2l0ZS9zaXRlMSJ9.thpdYXJuKWTDlStV-HHTv6PViEDZPrSQDO9C3aUo4mM",
}

/**
 * Returns GlobalOptions from localStorage (set at login).
 * Use this everywhere instead of fetching GlobalOptions again.
 * @returns {Array} GlobalOptions list or [] if not set
 */
export const getGlobalOptions = () => {
  try {
    const stored = localStorage.getItem("GlobalOptions")
    if (!stored) return []
    const parsed = JSON.parse(stored)
    return Array.isArray(parsed)
      ? parsed
      : parsed?.dataList
      ? parsed.dataList
      : [parsed]
  } catch {
    return []
  }
}

/** Get active options for the currently logged-in firm */
export const getActiveGlobalOptions = () => {
  const opts = getGlobalOptions()
  if (!opts || opts.length === 0) return null
  let firmId = null
  try {
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      firmId = parsed.FirmId || parsed.firmId || parsed.F_FirmMaster || parsed.f_FirmMaster
    }
    if (!firmId) {
      const firmSub = localStorage.getItem("firmSubscription")
      if (firmSub) {
        const parsedSub = JSON.parse(firmSub)
        firmId = parsedSub.firmId || parsedSub.FirmId || parsedSub.f_FirmMaster
      }
    }
  } catch (e) {}

  if (firmId) {
    const match = opts.find(o => String(o.F_FirmMaster) === String(firmId))
    if (match) return match
  }
  return opts[0] || null
}

/** Get default financial year id from GlobalOptions */
export const getDefaultFinancialYearId = () => {
  const opt = getActiveGlobalOptions()
  if (opt && opt.F_FinancialYearMaster != null) {
    return opt.F_FinancialYearMaster
  }
  const opts = getGlobalOptions()
  if (opts && opts.length > 0 && opts[0].F_FinancialYearMaster != null) {
    return opts[0].F_FinancialYearMaster
  }
  return 0
}

/** Company/Firm name from logged-in user or active GlobalOptions. Use in navbar, bills, pages, excel, pdf, etc. */
export const getCompanyName = () => {
  try {
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      const name = parsed?.FirmName || parsed?.firmName
      if (name && name !== "Default Firm") {
        return String(name).trim()
      }
    }
    const firmSub = localStorage.getItem("firmSubscription")
    if (firmSub) {
      const parsedSub = JSON.parse(firmSub)
      const name = parsedSub?.firmName || parsedSub?.FirmName
      if (name && name !== "Default Firm") {
        return String(name).trim()
      }
    }
  } catch (e) {}

  const opt = getActiveGlobalOptions()
  if (opt && opt.Name) {
    return String(opt.Name).trim()
  }
  return "My Trading Firm"
}

/** Address from logged-in firm or active GlobalOptions (single line: Address, City State) */
export const getCompanyAddress = () => {
  const opt = getActiveGlobalOptions()
  if (opt) {
    const parts = [opt.Address, opt.City, opt.State]
      .filter(Boolean)
      .map(s => String(s).trim())
    if (parts.length) return parts.join(", ")
  }
  try {
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      const parts = [parsed.Address, parsed.City, parsed.State]
        .filter(Boolean)
        .map(s => String(s).trim())
      if (parts.length) return parts.join(", ")
    }
  } catch (e) {}
  return ""
}

export const getCompanyCity = () => {
  const opt = getActiveGlobalOptions()
  if (opt && opt.City) return String(opt.City).trim()
  try {
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      if (parsed.City || parsed.city) return String(parsed.City || parsed.city).trim()
    }
  } catch (e) {}
  return ""
}

export const getCompanyState = () => {
  const opt = getActiveGlobalOptions()
  if (opt && opt.State) return String(opt.State).trim()
  try {
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      if (parsed.State || parsed.state) return String(parsed.State || parsed.state).trim()
    }
  } catch (e) {}
  return ""
}

export const getCompanyGstNo = () => {
  const opt = getActiveGlobalOptions()
  if (opt && opt.GstNo) return String(opt.GstNo).trim()
  try {
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      if (parsed.GstNo || parsed.gstNo || parsed.GSTNo) return String(parsed.GstNo || parsed.gstNo || parsed.GSTNo).trim()
    }
  } catch (e) {}
  return ""
}

export const getCompanyPanNo = () => {
  const opt = getActiveGlobalOptions()
  if (opt && opt.PanNo) return String(opt.PanNo).trim()
  return ""
}

export const getCompanyMobile = () => {
  const opt = getActiveGlobalOptions()
  if (opt && opt.Mobile) return String(opt.Mobile).trim()
  try {
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      if (parsed.MobileNo || parsed.mobileNo || parsed.Mobile) return String(parsed.MobileNo || parsed.mobileNo || parsed.Mobile).trim()
    }
  } catch (e) {}
  return ""
}
